const state = () => ({
    notifications: [],
});

const getters = {
};

const actions = {
};

const mutations = {
    addNotification(state, notification) {
        state.notifications.push({
            ...notification,
            isRead: false,
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};